<template>
  <div
    :class="{ 'text-red-500': modelValue === 0 }"
    class="ml-auto justify-self-end"
  >
    {{ modelValue }}
  </div>
</template>
<script setup lang="ts">
defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
});
</script>
